import { Box, Card, CardContent, Grid, Typography } from "@mui/material";

const focuses = [
  {
    id: 1,
    task: "Building",
    activity:
      "I keep building products and learning to make one. It is always my passion and something I do every day",
    emoji: "💻",
  },
  {
    id: 2,
    task: "Blogging",
    activity:
      "I document my tech journey and learning progress. It has inspired many people to join the tech industry",
    emoji: "✍️",
  },
  {
    id: 3,
    task: "Sharing",
    activity:
      "I share high-quality content, lessons and insights so everyone can take benefit from them",
    emoji: "🌏",
  },
  {
    id: 4,
    task: "Designing",
    activity:
      "I innovate design to fulfill the aesthetic requirements of the front-end. A mix of tech and design",
    emoji: "🎨",
  },
];

export default function Do() {
  return (
    <Box>
      <Typography
        sx={{ textAlign: "left", fontWeight: "bolder", fontSize: 30 }}
      >
        🪐 I do...
      </Typography>

      <Grid container spacing={1} sx={{ pt: 2 }}>
        {focuses.map(({ id, task, activity, emoji }) => (
          <Grid item key={id} xs={12} sm={12} md={6}>
            <Card sx={{ height: "100%", borderRadius: 3, bgcolor: "#1F2937" }}>
              <CardContent>
                <Typography variant="h6" component="div" sx={{ mb: 1.5 }}>
                  {task}
                  <span>{emoji}</span>
                </Typography>

                <Box sx={{ maxWidth: "80%", margin: "0 auto" }}>
                  <Typography variant="body2" sx={{ color: "darkgrey" }}>
                    {activity}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
